export default __webpack_public_path__ + "static/media/sliderContinuous_noThemeSelected.08886417.svg";